import request from '@/router/axios';

const pre_fix = '/dotadmin/manage/';

export function list(param) {
  return request({
    url: '/dotadmin/manage/pageQc',
    method: 'get',
    params: param,
  });
}

export function updateAbilityQcStatus(param) {
  return request({
    url: pre_fix + 'updateAbilityQcStatus',
    method: 'post',
    data: param,
  });
}

export function updateAbilityQcScore(param) {
  return request({
    url: pre_fix + 'updateAbilityQcScore',
    method: 'post',
    data: param,
  });
}

export function qcLogList(param) {
  return request({
    url: pre_fix + 'qcLogList',
    method: 'get',
    params: param,
  });
}

export function getTrAbilityQcAndLogByStaffId(param) {
  return request({
    url: pre_fix + 'getTrAbilityQcAndLogByStaffId',
    method: 'get',
    params: param,
  });
}
export function industry(param) {
  return request({
    url: '/dotadmin/field/getAllField',
    method: 'get',
    params: param,
  });
}

export function getAllEnableField(param) {
  return request({
    url: '/dotadmin/field/getAllEnableField',
    method: 'get',
    params: param,
  });
}

export function getQcInfo(param) {
  return request({
    url: '/dotadmin/manage/getQcInfo',
    method: 'get',
    params: param,
  });
}

// 判断是否强制修改密码
export function forceChangePwd() {
  return request({
    url: '/system/user/forceChangePwd',
    method: 'get',
  });
}
